import { HttpErrorResponse, HttpRequest } from '@angular/common/http';

/**
 * APIエラー
 * バックエンドとのHTTP通信エラー
 * Interceptorでエラーを受け取ったらrequestとresponseを設定してthrowする
 */
export class ApiError extends Error {
  /**
   * コンストラクタ
   * @param request リクエスト
   * @param response レスポンス
   * @param message エラーメッセージ
   */
  constructor(
    public request: HttpRequest<unknown>,
    public response: HttpErrorResponse,
    message = 'ApiError'
  ) {
    super(message);
  }
}

/**
 * アプリケーションエラー
 */
export class AppError extends Error {
  /**
   * コンストラクタ
   * @param message エラーメッセージ
   */
  constructor(message = 'ApplicationError') {
    super(message);
  }
}

/**
 * 到達不可能コードエラー
 * 通常の処理では入らないコードブロックに入った際に使うエラー
 */
export class UnreachableCodeError extends AppError {
  /**
   * コンストラクタ
   * @param message エラーメッセージ
   */
  constructor(message = 'UnreachableCodeError') {
    super(message);
  }
}

/**
 * 認証ユーザーエラー
 * 認証されたユーザー情報が取得できなった際のエラー
 */
export class NotAuthenticatedUserError extends AppError {
  /**
   * コンストラクタ
   * @param message エラーメッセージ
   */
  constructor(message = 'NotAuthenticatedUserError') {
    super(message);
  }
}

/**
 * テナント未選択エラー
 * テナントが選択されていない際のエラー
 */
export class NotSelectedTenantError extends AppError {
  /**
   * コンストラクタ
   * @param message エラーメッセージ
   */
  constructor(message = 'NotSelectedTenantError') {
    super(message);
  }
}
